<script>
export default {
  name: 'field',
};
</script>

<style scoped lang="sass">
</style>
